import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap, withLatestFrom } from "rxjs";

// Store
import { Store } from "@ngrx/store";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";
import { SportsbookFacade } from "../../../stores/sportsbook/sportsbook.facade";
import { SportsbookState } from "../../../stores/sportsbook/sportsbook.reducers";

// Services
import { DeviceService } from "@services/device.service";
import { SportService } from "@sports-services/sports.service";

// Utils
import { SPORTS_PATHS } from "@shared-constants/routes";

@Injectable({ providedIn: "root" })
export class SportsbookNavigationEffects {
  // Services
  actions$ = inject(Actions);
  sportService = inject(SportService);

  // Utils
  deviceService = inject(DeviceService);
  store = inject(Store<SportsbookState>);
  sportsbookFacade = inject(SportsbookFacade);

  navigationUpdate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(SportsbookActions.navigationUpdate),
        withLatestFrom(this.store.select("sportsbook")),
        tap(([{ type, ...payload }, data]) => {
          const targetUrl = payload.prevUrl.url?.split("?")[0].slice(1);
          const currentUrl = payload.currentUrl.url?.split("?")[0].slice(1);
          if (targetUrl !== currentUrl)
            setTimeout(() => {
              switch (targetUrl) {
                case SPORTS_PATHS.SportCountriesPage:
                  this.sportsbookFacade.clearSportCountries();
                  break;
                case SPORTS_PATHS.HomePage:
                  this.sportsbookFacade.clearHome();
                  break;
                case SPORTS_PATHS.DirectosPage:
                  this.sportsbookFacade.clearLive();
                  break;
                case SPORTS_PATHS.NowLiveDetailPage:
                  this.sportsbookFacade.clearLiveMarket();
                  break;
                case SPORTS_PATHS.EventoPage:
                  this.sportsbookFacade.clearEvent();
                  break;
                case SPORTS_PATHS.MercadosPage:
                  this.sportsbookFacade.clearMarket();
                  break;
                case SPORTS_PATHS.TodayPage:
                  this.sportsbookFacade.clearToday();
                  break;
                case SPORTS_PATHS.HorsesPage:
                  this.sportsbookFacade.clearRace();
                  break;
                case SPORTS_PATHS.HorsesMarketPage:
                  this.sportsbookFacade.clearRaceMarket();
                  break;
              }
            }, 500); // We allow time for the component to be destroyed and prevent console errors.
        }),
      ),
    { functional: true, dispatch: false },
  );
}
